<template lang="html">
    <div id="account">
        <header>
            Security settings
            <router-link :to="{ name: 'Account' }"
                ><chevron-left-icon class="icon"></chevron-left-icon
            ></router-link>
        </header>

        <form class="form privacy">
            <div class="formGroup">
                <p class="help">
                    Activate 2-step verification and you will be asked for your password and
                    verification code when you sign in to your account.
                </p>
            </div>
            <div class="formGroup b">
                <label class="highlight">Enable 2 factor auth</label>

                <toggle-switch @input="savePrivacy" v-model="form.two_factor_auth" />
            </div>
        </form>
    </div>
</template>

<script>
import { Form } from "vform";
import ToggleSwitch from "@/components/App/toggle-switch.vue";
import { ChevronLeftIcon } from "vue-feather-icons";
export default {
    name: "privacy",
    components: { ToggleSwitch, ChevronLeftIcon },
    data() {
        return {
            form: new Form({
                two_factor_auth: "",
            }),
        };
    },
    mounted() {
        if (this.$store.state.user.settings) {
            this.form.fill(this.$store.state.user.settings);
        }
    },
    methods: {
        savePrivacy() {
            this.form.post("/settings").then((settings) => {
                this.$store.dispatch("updateUserSettings", settings.data);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.privacy {
    .switch {
        position: absolute;
        right: 0px;
        top: 12px;
    }
    .formGroup {
        margin-bottom: 30px;
    }
}
</style>
